import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';
import { loadingService } from '../loading.service';

@Injectable()
export class FinanceService {

  constructor(
    private apiService: ApiService,
    private loadingService: loadingService
    ) { }

  getBillingList(id) {
    this.loadingService.showLoading();
    return this.apiService.send('finance/getbillinglist', {id: id})
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })

    }
  saveAllBilling(payload) {
    this.loadingService.showLoading();
    return this.apiService.send('finance/saveAllBilling', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }


}



// WEBPACK FOOTER //
// ./src/app/core/service/app/finance.service.ts